<template>
    <div class="p-3" v-if="!error">
        <el-card header="Viagens da empresa">
            <ElForm ref="formRef" label-position="top" inline :model="searchData">
                <ElFormItem label="Datas das viagens" class="col-12 col-md-5 col-lg-4" prop="dates">
                    <ElDatePicker type="daterange" range-separator="-" start-placeholder="Desde" end-placeholder="Até" v-model="searchData.dates" />
                </ElFormItem>

                <ElFormItem label="buscar">
                    <ElButton :loading="loading" type="primary" @click="search">Procurar viagens</ElButton>
                </ElFormItem>
            </ElForm>
            <PersonalTable :loading="loading" :height="400" :showRows="10" :cols="[
                {label: 'Cod', prop: 'id'},
            ]" :data="trips" >
                <el-table-column label="Data e hora de partida" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ new Date(data.row.departure).toLocaleString("af") }}
                        <ElTag :type="new Date(data.row.departure) < new Date() ? 'danger':'success'">{{ new Date(data.row.departure) < new Date() ? 'Realizada':'Disponivel' }}</ElTag>
                    </template>
                </el-table-column>
                <el-table-column label="Empresa" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.car.travel_company.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Carro" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.car.name }} [{{ data.row.car.plate }}]
                    </template>
                </el-table-column>
                <el-table-column label="Rota de viagem" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.route.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" tag="router-link" :to="'/companies-dashboard/travel/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PersonalTable>

            <ElButton @click="back">Voltar ao painel</ElButton>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount, reactive, ref } from 'vue'
    import { ElMessageBox, ElForm, ElFormItem, ElDatePicker, ElButton, FormInstance, ElTag } from 'element-plus';
    import { Travel } from '@/services/types';
    import { useRouter } from 'vue-router';

    const loading = ref<boolean>(true)
    const error = ref<boolean>(false)
    const trips = ref<Array<Travel>>([])
    const router = useRouter()
    const formRef = ref<FormInstance>()

    const back = () => {
        router.push('/companies-dashboard')
    }

    const searchData = reactive<{travel_company_id: number, dates: Array<string>}>({travel_company_id: 0, dates: []})
    
    const getTrips = async (id: number | false | null = 0, dates: Array<string> | undefined | false = false) => {
        const params = new URLSearchParams()
        params.append('phone', sessionStorage.getItem('phone') ?? '')
        params.append('password', sessionStorage.getItem('password') ?? '')
        if (id && id > 0) {
            params.append('travel_company_id', id.toString())
        } 
        if (dates) {
            params.append('start', new Date(dates[0]).toISOString())
            params.append('end', new Date(dates[1]).toISOString())
        }
        const res = await Api.get(`companies/travel?${params.toString()}`)
        if (res.status == 200) {
            console.log(res)
            error.value = false
            trips.value = res.data.travel
        } else {
            console.log(res)
            error.value = true
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }

    const search = async () => {
        loading.value = true
        await getTrips(searchData.travel_company_id, searchData.dates)
        loading.value = false
    }
    
    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getTrips(),
        ])
        loading.value = false
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
